const KEY_PREFIX = "speak:lastUploadFolderId";
const key = (userId: string) => `${KEY_PREFIX}:${userId}`;

export function getLastUploadFolderId(userId: string | undefined): string | null {
  if (!userId) return null;
  try {
    return localStorage.getItem(key(userId)) || null;
  } catch {
    return null;
  }
}

export function setLastUploadFolderId(userId: string | undefined, folderId: string): void {
  if (!userId || !folderId) return;
  try {
    localStorage.setItem(key(userId), folderId.slice(0, 64));
  } catch {
    /* localStorage unavailable — non-fatal */
  }
}

/** Default upload destination: the last folder the user uploaded into (if it
 *  still exists in their folder list), else the first folder. */
export function resolveDefaultUploadFolderId(
  folders: { folderId?: string }[],
  lastUsedId: string | null,
): string | undefined {
  if (folders.length === 0) return undefined;
  if (lastUsedId && folders.some((f) => f.folderId === lastUsedId)) return lastUsedId;
  return folders[0]?.folderId;
}
